import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import IconButton from "@mui/material/IconButton";
import "./copyClipboard.scss";
type Props = {
  texte: string
};

const ClipBoardTexte = (props: Props, child?: React.ReactNode) => {
  const parts = props.texte.split(' ');

  const handleCopy = async (event: React.SyntheticEvent, texte: string) => {
    event.stopPropagation();
    try {
      await navigator.clipboard.writeText(texte);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

    return (
      <>
    {parts.map((part, i) => {
            // Check if the part matches one of the keywords
            let texteAffPrefix = "";
            let texteAff = part;
            let texteAffSuffix = " ";
            let texteCopy = "";
            if (part.startsWith('[') && part.endsWith(']')) {
              texteAffPrefix = "[";
              texteCopy = part.substring(1,part.length-1);
              texteAffSuffix = "] ";
            } else if (part.endsWith('^c')) {
              texteAff = part.substring(0,part.length-2);
              texteCopy = part.substring(0,part.length-2);
            }

            
            if (texteCopy.length > 0) {
              texteAff = texteCopy;
              return (
                <>
                {texteAffPrefix}
                <span className='copy-clipboard'>{texteAff}
                <IconButton
                          key={"ib"+i}
                          sx={{
                            height: "2px",
                            width: "20px",
                          }}
                          color="primary"
                          onClick={(e) => handleCopy(e, texteCopy)}
                        >
                          <ContentCopyIcon
                            key={"cci"+i}
                            fontSize="inherit"
                            sx={{
                              height: "17px",
                            }}
                          />
                        </IconButton>
                  </span>
                  {texteAffSuffix}
                  </>
              );
            }
            else {
              return <>{texteAff+texteAffSuffix} </>;
            } 
          })}
      </>
    );
};

export default ClipBoardTexte;
